notifications-table
  section.app-table
    header.app-table-header
      .row
        .col-12
          b.content
            | { opts.locale.header.content.label }
    .app-table-body
      .row(each="{ opts.items }")
        .col-12
          notifications-item(tag-scope="notification_{id}" inview="{true}")
  shared-paginate(tag-scope="{this.tagScope}.paginate")
  script(type="typescript").
    this.mixin('notifications.table');
  style(scoped).
    :scope {
      display: block;
    }
    .feather {
      width: 40px;
      height: 40px;
      font-size: 16px;
      padding: 12px 13px;
      border-radius: 50%;
      text-align: center;
      color: #fff;
      margin-right: 10px;
    }
    .media-body.unread:after {
      content: '';
      display: block;
      position: absolute;
      left: 10px;
      top: 0px;
      background: #ff5252;
      width: 5px;
      height: 5px;
      border-radius: 50%;
    }
    .notification-msg {
      margin: 0;
    }
    .notification-title {
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 5px;
    }
    .notification-time {
      font-size: 12px;
      color: #919aa3;
    }
